import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api'

export interface TrendingPrompt {
  queryText: string
  queryType: string
  sourceUrls: string[]
}

export interface TrendingPromptsResponse {
  prompts: TrendingPrompt[]
  source: 'cache' | 'industry-fallback' | 'empty'
  refreshedAt: string | null
  stale: boolean
  canRefresh: boolean
  refreshCost: number
}

export interface TrendingPromptsRefreshResponse {
  prompts: TrendingPrompt[]
  source: 'perplexity' | 'cache' | 'industry-fallback' | 'empty'
  refreshedAt: string | null
  charged: number
}

export function useTrendingPrompts(websiteId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['trending-prompts', websiteId],
    queryFn: () =>
      api.get<TrendingPromptsResponse>(
        `/api/prompts/trending${websiteId ? `?website_id=${websiteId}` : ''}`
      ),
    enabled,
  })
}

export function useRefreshTrendingPrompts(websiteId: string | null) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => api.post<TrendingPromptsRefreshResponse>('/api/prompts/trending/refresh', { website_id: websiteId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['trending-prompts', websiteId] })
    },
  })
}
